import styles from './App.module.css'
import "react-toastify/dist/ReactToastify.css";
import cx from "classnames";
import Navigation from "./components/Navigation";
import {useGlobalContext} from "./contexts/globalContext";
import Individualization from "./pages/Individualization";
import Settings from "./pages/Settings";
import Orders from "./pages/Orders";
import {Link} from "./types/Link";
import {AdminContextProvider} from "./contexts/AdminContext";
import TrialCard from "./compositions/Settings/SubscriptionSettings/TrialCard";
import Subscription from "./pages/Subscription";

const Admin = () => {
    const {activeTab, setActiveTab, fullscreen} = useGlobalContext()

    const links: Link[]= [
        {
            number: 1,
            name: 'nav1',
        },
        {
            number: 2,
            name: 'nav2',
        },
        {
            number: 3,
            name: 'nav3',
        },
        {
            number: 4,
            name: 'nav4',
        },
    ]

    return (
        <AdminContextProvider>
            <div className={cx(styles["zr-main-container"], fullscreen && styles["zr-fullscreen"])}>
                <Navigation active={activeTab} setActive={setActiveTab} links={links}/>
                <div className={cx(styles["zr-main-content"])}>
                    <TrialCard/>
                    {activeTab.number === 1 && <Individualization/>}
                    {activeTab.number === 2 && <Settings/>}
                    {activeTab.number === 3 && <Orders/>}
                    {activeTab.number === 4 && <Subscription/>}
                </div>
            </div>
        </AdminContextProvider>
    )
}

export default Admin;
